import { AvatarInput } from '@vueling-ng/vy-ds/src/lib/components/globals/avatar';
import { MenuVerticalItem } from '@vueling-ng/vy-ds/src/lib/components/globals/menu-vertical';

export interface AccountManagementData {
  language: string;
  userName: string;
  email: string;
}
export interface AccountManagementViewModel {
  userAvatar: AvatarInput;
  userName: string;
  userEmail: string;
  navigationList: MenuVerticalItem[];
}

export const AccountManagementViewModelEMPTY: AccountManagementViewModel = {
  userAvatar: {
    title: {
      firstLetter: '',
      secondLetter: ''
    }
  },
  userName: '',
  userEmail: '',
  navigationList: []
};
